const defaultFilter = null

const state = {
  documentAnalyzeFilter: defaultFilter
}

const getters = {}

const mutations = {
  SET_FILTER: (state, payload) => {
    state.documentAnalyzeFilter = payload
  }
}

const actions = {
  loadFilter({ commit }, filterData) {
    commit('SET_FILTER', filterData)
  },
  clearDocumentAnalyzeFilter({ commit }) {
    const defaultFilter = null
    commit('SET_FILTER', defaultFilter)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
